<template>
  <div class="banner">
    <img class="bannerImg" :src="bannerImg" alt />
    <img class="bannerImg" :src="bannerImg1" alt />
    <div class="banner_text">

      <div class="wenzi1">
        <img :src="wenziImg1" />
      </div>
      <div class="wenzi2">
        《007：无暇赴死》在中国大陆上映7天，票房突破2.3亿元，位居猫眼一周内地票房榜榜首！数次斩获“单日票房冠军”等荣誉，是今年第二部全球票房超过6亿美元的好莱坞电影。 

        <p>007系列电影的原著作者——“007之父”伊恩·弗莱明将自己的传奇经历和感受融入作品中，从而创作出了一部部精彩绝伦又扣人心弦的畅销经典。007系列电影原著，比电影毫不逊色的读本！</p>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "banner",
  props: {
      bannerImg: {
          type:String,
          default:''
      },
      bannerImg1: {
          type:String,
          default:''
      },
      wenziImg: {
          type:String,
          default:''
      },
      wenziImg1: {
          type:String,
          default:''
      },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 14rem;
position: relative;
  .bannerImg {
        width: 100%;

  }
  .banner_text {
    position: absolute;
    top: 0;
    padding-top:1.71rem ;
    z-index: 1000;
    width: 12rem;
    left: 50%;
    margin-left:-6rem ;
  
    .wenzi{
        margin-bottom: 0.4rem;
        width: 5.94rem;
        margin: 0 auto;
        img{
          width: 100%;
        }
    }
    .wenzi1{
        margin-bottom: 0.4rem;
         width: 100%;
         
        img{
          width: 100%;
        }
    }
    .wenzi2{
    
        font-size: 0.34rem;
        line-height: 0.6rem;
        color: #FBF5B8;
        font-family: Source Han Sans SC;
      text-align: left;
    }
  }

}
</style>
